/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentAccessLogResponseDto } from '../../models/document-access-log-response-dto';

export interface DocumentAccessLogControllerGetUserAccessLogs$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * User ID
 */
  userId: string;

/**
 * Number of logs to return (default: 50)
 */
  limit?: number;

/**
 * Start time filter (Unix timestamp)
 */
  startTime?: number;

/**
 * End time filter (Unix timestamp)
 */
  endTime?: number;
}

export function documentAccessLogControllerGetUserAccessLogs(http: HttpClient, rootUrl: string, params: DocumentAccessLogControllerGetUserAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, documentAccessLogControllerGetUserAccessLogs.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('userId', params.userId, {});
    rb.query('limit', params.limit, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentAccessLogResponseDto>>;
    })
  );
}

documentAccessLogControllerGetUserAccessLogs.PATH = '/thalea-documents/access-logs/{tenant}/users/{userId}/logs';
